import { render } from "./DriverGuideIndex.vue?vue&type=template&id=1adecd48"
import script from "./DriverGuideIndex.vue?vue&type=script&lang=js"
export * from "./DriverGuideIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__